<template>
  <div class="spaces-modal" :class="{'is--large': large }">
    <div class="spaces-modal__box">
      <a href="#" @click.prevent="$emit('close')" class="space-modal__close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.111 26.241" xml:space="preserve"><g fill="#7A7A7A"><path d="M3.883 1 25.094 22.21l-2.828 2.829L1.054 3.828z"></path><path d="M25.098 3.829 3.885 25.042l-2.83-2.83L22.268 1z"></path></g></svg>
      </a>
      <div v-html="description"></div>
      <slot></slot>
    </div>
    <div @click.prevent="$emit('close')" class="spaces-modal__bg"></div>
  </div>
</template>

<script>
export default {
  props: {
    description: String,
    large: {
      type: Boolean,
      default: null
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import "../../scss/global/includes";

.spaces-modal {
  position: fixed;
  z-index: 10009;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.spaces-modal__box {
  position: fixed;
  z-index: 1009;
  top: 50%;
  left: 50%;
  @include transform(translate(-50%, -50%));
  width: 300px;
  background: #FFFFFF;
  border-radius: 6px;
  padding: 5vw 3vw;
  border: 1px solid #9B9B9B;
}

.is--large {
    .spaces-modal__box {
    width: 950px;
    padding: 2.5vw;
    @include breakpoint(tablet) {
      width: 90%;
    }
  }
}

.spaces-modal__bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255,255,255,0.3);
}

.space-modal__close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;
}



</style>